import { RefObject } from 'react';
import { BaseToolbarButton } from 'modules/dynamicContentBuilder/components/contentPicker/selectedContent/CustomTextInput/toolbar/BaseToolbarButton';
import { MediumContent } from 'modules/graphql';
import { MediumDataKey } from 'modules/templateEditor/common';
import { useEditableFieldsContext } from 'modules/templateEditor/context/EditableFieldsContext';
import { TipPlacement } from 'ui/tooltip';
import {
  TextFormatBold16,
  TextFormatCode16,
  TextFormatItalics16,
  TextFormatStrikethrough16,
} from 'ui/icons';

export const WhatsAppFormattingButtons = ({
  inputRef,
  mediumField,
}: {
  inputRef?: RefObject<HTMLTextAreaElement> | null;
  mediumField: string;
}) => {
  const { liveTemplate, setCurrentMediumField } = useEditableFieldsContext();
  const mediumData = (liveTemplate?.mediumData || {}) as MediumContent;

  // WhatsApp does not follow standard Markdown formatting and instead has their own separate formatting https://developers.facebook.com/docs/whatsapp/on-premises/reference/messages/#formatting
  // We should be able to reuse this method for wrapping selected text to apply Markdown in the future though
  const handleFormat = (formattingWrapperStart: string, formattingWrapperEnd?: string) => {
    let startPosition = inputRef?.current?.selectionStart;
    let endPosition = inputRef?.current?.selectionEnd;
    if (startPosition !== endPosition) {
      const dataField = mediumData[mediumField as keyof MediumContent] as unknown as string;
      if (typeof startPosition === 'number' && typeof endPosition === 'number') {
        while (dataField[startPosition] === ' ' && startPosition < endPosition) {
          startPosition += 1;
        }
        while (dataField[endPosition - 1] === ' ' && startPosition < endPosition) {
          endPosition -= 1;
        }
      }
      const formatted = dataField
        .slice(0, startPosition)
        .concat(formattingWrapperStart)
        .concat(dataField.slice(startPosition, endPosition))
        .concat(formattingWrapperEnd ?? formattingWrapperStart)
        .concat(dataField.slice(endPosition, dataField.length));
      setCurrentMediumField(mediumField as MediumDataKey, formatted);
    }
    inputRef?.current?.focus();
  };
  return (
    <>
      <BaseToolbarButton
        isSelected={false}
        onClick={() => handleFormat('*')}
        tooltipPlacement={TipPlacement.Bottom}
        tooltip="Bold"
      >
        <TextFormatBold16 />
      </BaseToolbarButton>
      <BaseToolbarButton
        isSelected={false}
        onClick={() => handleFormat('_')}
        tooltipPlacement={TipPlacement.Bottom}
        tooltip="Italicize"
      >
        <TextFormatItalics16 />
      </BaseToolbarButton>
      <BaseToolbarButton
        isSelected={false}
        onClick={() => handleFormat('```')}
        tooltipPlacement={TipPlacement.Bottom}
        tooltip="Code"
      >
        <TextFormatCode16 />
      </BaseToolbarButton>
      <BaseToolbarButton
        isSelected={false}
        onClick={() => handleFormat('~')}
        tooltipPlacement={TipPlacement.Bottom}
        tooltip="Strikethrough"
      >
        <TextFormatStrikethrough16 />
      </BaseToolbarButton>
    </>
  );
};
